import React, { useEffect, useCallback, useState} from 'react';
import EffectParameterSlider from 'components/effects/EffectParameterSlider.js';
import {WAVEFORMS} from 'constants/waveforms.js';
import {connect} from 'react-redux';

const BASIC = 'BASIC';
const FAT = 'FAT';
const CUSTOM = 'CUSTOM';

const ALL_WAVEFORMS = {
    BASIC: [
        'sine',
        'triangle',
        'square',
        'sawtooth',
        'pulse',
    ],
    FAT: [
        'fatsquare',
        'fatsine',
        'fattriangle',
        'fatsawtooth'
    ],
    CUSTOM: WAVEFORMS
};

const WaveformSelector = ({
    oscillator,
    oscillatorType,
    customOscillatorType,
    hide,
}) => { 
    const [type, setType] = useState(BASIC);

    useEffect(() => {
        if (customOscillatorType) {
            setType(CUSTOM);
        }
    }, [customOscillatorType]);

    useEffect(() => {
        if (oscillatorType) {
            if (ALL_WAVEFORMS[BASIC].includes(oscillatorType)) {
                setType(BASIC);
            } else {
                setType(FAT);
            }
        }
    }, [oscillatorType]);

    const selectWaveform = useCallback((t) => {
        if (type === CUSTOM) {
            oscillator.customOscillatorTypeParameter.set(t);
        } else {
            oscillator.oscillatorTypeParameter.set(t);
        }
    }, [oscillator, type]);

    useEffect(() => {
        window.addEventListener('mousedown', hide);
        return () => window.removeEventListener("mousedown", hide);
    }, [hide]);


    return (
        <div
          onMouseDown={(e) => e.stopPropagation()}
          //onMouseUp={(e) => e.stopPropagation()}
          className="waveform-selector">
          {oscillator.customOscillatorType ?
           <EffectParameterSlider
             name="Harmonics"
             sequencerEngine={oscillator.sequencerEngine}
             isParameter={true}
             parameter={oscillator.harmonicsParameter}
             step={0.001}
             min={-1} max={1}/>
           : 
             <EffectParameterSlider
               name="Partials"
               sequencerEngine={oscillator.sequencerEngine}
               isParameter={true}
               parameter={oscillator.partialCountParameter}
               step={1}
               min={0} max={64}/>}
          <div className="inner">
            <div className="types">
              <Option type={BASIC} name="Basic" setType={setType} selectedType={type}/>
              <Option type={FAT} name="Fat" setType={setType} selectedType={type}/>
              <Option type={CUSTOM} name="Custom" setType={setType} selectedType={type}/>
            </div>
            <div className="waveforms">
              {ALL_WAVEFORMS[type].map(
                  t => <div
                         key={t}
                         onClick={() => selectWaveform(t)}
                         className={
                             customOscillatorType === t 
                                 || (!customOscillatorType && oscillatorType === t) ? "osc-type selected" : "osc-type"}>{t}</div>)}
            </div>
          </div>
       </div>
    );
}

const Option = ({type, name, setType, selectedType}) => {
    let className = "type-option";
    if (type === selectedType) {
        className += " selected";
    }
    return (
        <div onMouseDown={(e) => {
            e.stopPropagation();
            setType(type);
        }} className={className}>
          {name}
        </div>
    );
};

const mapStateToProps = (state, props) => {
  return {
      oscillatorType: props.oscillator.oscillatorType,
      customOscillatorType: props.oscillator.customOscillatorType
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(WaveformSelector);
